<template>
    <div>
        <Hero id="product"></Hero>
        <Features id="features"></Features>
        <Trial></Trial>
        <Pricing id="pricing"></Pricing>
        <Footer></Footer>

        <Cookies @acceptCookies="acceptCookies" @dismissCookies="dismissCookies" v-if="!cookies_accepted && !cookies_dismissed"></Cookies>
        <EnvironmentWarning v-if="$page.props.env !== undefined" :env="$page.props.env"/>
    </div>
</template>

<script>
import Hero from "@/Pages/Presentation/Hero";
import Pricing from "@/Pages/Presentation/Pricing";
import Footer from "@/Pages/Presentation/Footer";
import Features from "@/Pages/Presentation/Features";
import Showcase from "@/Pages/Presentation/Showcase";
import Cookies from "./Cookies";
import Trial from "./Trial";
import EnvironmentWarning from "./EnvironmentWarning";

export default {
    name: "Show",
    components: {
        EnvironmentWarning,
        Trial,
        Cookies,
        Showcase,
        Features,
        Footer,
        Pricing,
        Hero
    },
    data() {
        return {
            cookies_accepted: this.$page.props.cookies_accepted,
            cookies_dismissed: false,
        }
    },
    methods: {
        acceptCookies(){
            axios.post(route('cookies.accept'), {})
            .then( () => {
                this.cookies_accepted = true;
            });
        },
        dismissCookies(){
            this.cookies_dismissed = true;
        }
    }

}
</script>

<style scoped>

</style>
